import React from 'react'
import { FormattedMessage } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'

import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import LineUserMdIcon from 'LuxKit/Icons/line/LineUserMdIcon'
import LineWeightIcon from 'LuxKit/Icons/line/LineWeightIcon'
import LineBooksIcon from 'LuxKit/Icons/line/LineBooksIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineLayersIcon from 'LuxKit/Icons/line/LineLayersIcon'
import LineBedDoubleIcon from 'LuxKit/Icons/line/LineBedDoubleIcon'
import LineBoltIcon from 'LuxKit/Icons/line/LineBoltIcon'
import LineDashboardIcon from 'LuxKit/Icons/line/LineDashboardIcon'
import LineRulerIcon from 'LuxKit/Icons/line/LineRulerIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'

const FactsGrid = styled.div`
  display: grid;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const shipFactIconMap: Record<string, React.ComponentType<any>> = {
  length: LineRulerIcon,
  height: LineRulerIcon,
  passenger_capacity: LineUsersAltIcon,
  crew_capacity: LineUserMdIcon,
  weight: LineWeightIcon,
  performance: LineDashboardIcon,
  history: LineBooksIcon,
  registry: LineShieldCheckIcon,
  certifications: LineShieldCheckIcon,
  decks: LineLayersIcon,
  accommodation: LineBedDoubleIcon,
  construction: LineBoltIcon,
  technical: LineBoltIcon,
  capacity: LineUsersAltIcon,
  dimensions: LineRulerIcon,
  other: LineShipIcon,
}

interface Props {
  offer: App.CruiseOffer
}

function CruiseShipFacts({
  offer,
}: Props) {
  const shipFacts = offer.ship.facts || []
  if (!shipFacts.length) return null

  return <FactsGrid>
    {shipFacts.map(fact => {
      const Icon = shipFactIconMap[fact.category]
      return <BodyTextBlock
        variant="medium"
        key={fact.name}
        startIcon={Icon ? <Icon /> : null}
      >
        <FormattedMessage
          id="Cm9mBnQ0Rm"
          defaultMessage="{name}: <bold>{description}</bold>"
          description="Cruise ship fact list item displaying the fact name and its corresponding value"
          values={{
            name: fact.name,
            description: fact.description,
            bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
          }}
        />
      </BodyTextBlock>
    })}
  </FactsGrid>
}

export default CruiseShipFacts
